import { useValidationQuery } from 'app/developer-v3/hooks';
import {
  MODES as SIDEBAR_RIGHT_MODES,
  TABS as SIDEBAR_RIGHT_TABS,
  useSidebarRight,
} from 'app/developer-v3/components/SidebarRight';
import type { SemVer } from 'app/developer-v3/types/version';

type Params = {
  id: string | number;
  onFailure: () => void;
  onSuccess: () => void;
  version: SemVer;
};

export default function useSidebarRightToPublish(params: Params) {
  const { id, version, onSuccess, onFailure } = params;

  const { update: updateSidebarRight } = useSidebarRight();

  const mode = SIDEBAR_RIGHT_MODES.PUBLISHING;

  const { isValidating, validate } = useValidationQuery({
    mode,
    appId: id,
    version,
    fetchPolicy: 'cache-and-network',
    isLazy: true,
    onCompleted: data => {
      const { hasFailures } =
        data?.platformIntegration?.implementation?.checks || {};

      // This shouldn't be a real scenario. Cypress tests for this functionality
      // Are flaky where we'll mock Apollo errors and still have onCompleted called
      // within useValidationQuery rather than onError. Not sure if this is a Cypress
      // bug or an Apollo bug, but accounting for it here in case it's a potential
      // Apollo bug.
      if (!data) {
        onFailure();
        return;
      }

      if (hasFailures) {
        updateSidebarRight({ mode, tabActive: SIDEBAR_RIGHT_TABS.VALIDATE });
        return;
      }

      onSuccess();
    },
    onError: () => {
      onFailure();
    },
  });

  return { isValidating, validate };
}
